import * as Roles from '@/store/roles';

export const diaryEntryActionsPermissions = {
  addDiaryEntry: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  addSyncedDiaryEntry: [Roles.Any],
  getDiaryEntries: [
    Roles.Admin,
    Roles.ProjectLeader,
    Roles.Trial,
    Roles.SiteManager,
    Roles.SiteAssistant,
    Roles.SubContractor,
    Roles.Client,
  ],
  getDefaultDiaryEntry: [Roles.Any],
  saveDiaryEntryProperties: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  updateDiaryUnassigned: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  setDiaryEntryProperties: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  diaryEntrySetItemProperties: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  diaryEntryRemoveItem: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  diaryEntryAddItem: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  selectDiaryEntry: [
    Roles.Admin,
    Roles.ProjectLeader,
    Roles.Trial,
    Roles.SiteManager,
    Roles.SiteAssistant,
    Roles.Client,
  ],
  getPreviousDiaryEntryForDate: [Roles.Any],
  mergeDiaryEntry: [Roles.Any],
  syncDiaryEntry: [Roles.Any],
  syncDiaryEntryProperties: [Roles.Any],
  updateDiaryEntryCompanies: [Roles.Any],
  getDiaryEntryForDate: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
  loadProjectDiaryEntries: [
    Roles.Admin,
    Roles.ProjectLeader,
    Roles.Trial,
    Roles.SiteManager,
    Roles.SiteAssistant,
    Roles.SubContractor,
    Roles.Client,
  ],
  diaryEntryViewOtherComments: [Roles.Admin, Roles.ProjectLeader, Roles.Trial, Roles.SiteManager, Roles.SiteAssistant],
};



// WEBPACK FOOTER //
// ./src/store/diaryEntry/diaryEntryActionsPermissions.js